import { Link, useNavigate } from 'react-router-dom';
import { useAuthStore } from '../../stores/auth';
import { authApi } from '../../api/client';
import './Header.css';

export function Header() {
    const { user, isAuthenticated, logout } = useAuthStore();
    const navigate = useNavigate();

    const handleLogout = async () => {
        try {
            await authApi.logout();
        } catch {
            // 即使服务端销毁失败也清除本地状态
        }
        logout();
        navigate('/');
    };
    return (
        <header className="header">
            <div className="header-container container">
                <div className="header-left">
                    <Link to="/" className="header-logo">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="logo-icon-sm">
                            <circle cx="12" cy="12" r="10" />
                            <circle cx="12" cy="12" r="3" fill="currentColor" stroke="none" />
                        </svg>
                        <span>GitCenter</span>
                    </Link>

                    <nav className="header-nav">
                        <Link to="/explore" className="nav-link">探索</Link>
                        {isAuthenticated && (
                            <>
                                <Link to="/dashboard" className="nav-link">仪表盘</Link>
                                <Link to="/groups" className="nav-link">群组</Link>
                            </>
                        )}
                    </nav>
                </div>

                <div className="header-right">
                    {isAuthenticated ? (
                        <>
                            <Link to="/new/project" className="btn btn-primary btn-sm">
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
                                    <path d="M8 2a.75.75 0 0 1 .75.75v4.5h4.5a.75.75 0 0 1 0 1.5h-4.5v4.5a.75.75 0 0 1-1.5 0v-4.5h-4.5a.75.75 0 0 1 0-1.5h4.5v-4.5A.75.75 0 0 1 8 2Z" />
                                </svg>
                                新建
                            </Link>

                            <div className="user-menu">
                                <button className="user-avatar">
                                    {user?.avatarUrl ? (
                                        <img src={user.avatarUrl} alt={user.username} />
                                    ) : (
                                        <span>{user?.username?.charAt(0).toUpperCase()}</span>
                                    )}
                                </button>
                                <div className="user-dropdown">
                                    <div className="dropdown-header">
                                        <strong>{user?.username}</strong>
                                        <span>{user?.email}</span>
                                    </div>
                                    <div className="dropdown-divider" />
                                    <Link to={`/${user?.username}`} className="dropdown-item">个人主页</Link>
                                    <Link to="/settings" className="dropdown-item">设置</Link>
                                    {user?.role === 'admin' && (
                                        <>
                                            <div className="dropdown-divider" />
                                            <Link to="/admin" className="dropdown-item">管理控制台</Link>
                                        </>
                                    )}
                                    <div className="dropdown-divider" />
                                    <button className="dropdown-item dropdown-item-danger" onClick={handleLogout}>
                                        退出登录
                                    </button>
                                </div>
                            </div>
                        </>
                    ) : (
                        <>
                            <Link to="/login" className="btn btn-primary">登录</Link>
                        </>
                    )}
                </div>
            </div>
        </header>
    );
}
